module.exports = __webpack_public_path__ + "media/images/lupa_verde-7273fce756462b96fb46567ec107aeeb.svg";